import styles from './aircraftIncidentModal.module.scss';
import Image from 'next/image';

const AircraftIncidentModal: React.FC = () => {
  const handleContentClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent} onClick={handleContentClick}>
        <div className={styles.logoContainer}>
          <Image
            src="/img/modal/success-logo.webp"
            alt="Hera Flight"
            width={136}
            height={108}
          />
        </div>
        <h2 className={styles.title}>
          Hera Flight can confirm that one of our aircraft was involved in an
          incident today.
        </h2>
        <p className={styles.message}>
          Our immediate priority is the safety and care of the passengers, crew,
          and their families. We are cooperating fully with the authorities to
          determine the cause. We will provide updates as soon as confirmed
          information becomes available. <br /> <br /> Out of respect for those
          affected, we will not release further details at this time.
        </p>
      </div>
    </div>
  );
};

export default AircraftIncidentModal;
